import script from "./SavePreset.vue?vue&type=script&setup=true&lang=js"
export * from "./SavePreset.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__